import React from 'react'
import { createApiClientContext } from '@chilipiper/api-client-shared'
import { getApiV2Config, initAppInfo } from '@chilipiper/service/src/apiClientConfig'
import { type Clients, type MockedClients, buildClients, buildMockedClients } from './api-client/getClients'

initAppInfo('chilical', __APP_VERSION__)
const apiConfig = getApiV2Config()

const {
  ApiClientProvider: ApiClientProviderRoot,
  MockedApiClientProvider,
  useApiClient,
} = createApiClientContext<Clients, MockedClients>({
  buildClients,
  buildMockedClients,
})

export { MockedApiClientProvider, useApiClient }
export type { MockedClients }

export const ApiClientProvider = ({ children }: { children: React.ReactNode }) => {
  return <ApiClientProviderRoot apiConfig={apiConfig}>{children}</ApiClientProviderRoot>
}
